import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6} sm={6}>{new Date().getFullYear()} © Mount Electronics. All rights reserved.</Col>
            <Col md={6} sm={6}>
              <div className="text-sm-end d-sm-block">
                Design & Development by
                <Link to="#" className="ms-1 text-primary"> 
                  HIS
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
